export default "__VITE_ASSET__DFuKKpSs__"